/* from: 
    RGBToHSL - https://www.30secondsofcode.org/js/s/rgb-to-hsl/
*/

/**
    @param {number} r red color (0-255)
    @param {number} g green color (0-255)
    @param {number} b blue color (0-255)
    @returns {[hue, saturation, lightness]} array of HSL
    @description convert rgb to hsl
*/
const RGBToHSL = (r = 0, g = 0, b = 0) => {
  r /= 255;
  g /= 255;
  b /= 255;
  const l = Math.max(r, g, b);
  const s = l - Math.min(r, g, b);
  const h = s
    ? l === r
      ? (g - b) / s
      : l === g
      ? 2 + (b - r) / s
      : 4 + (r - g) / s
    : 0;
  return [
    60 * h < 0 ? 60 * h + 360 : 60 * h,
    100 * (s ? (l <= 0.5 ? s / (2 * l - s) : s / (2 - (2 * l - s))) : 0),
    (100 * (2 * l - s)) / 2,
  ];
};
export default RGBToHSL;
